import { PublicAnnounceArtist as GQLItem } from '../generated/checkout.graphql';
import * as CheckoutArtistLink from './CheckoutArtistLink';
import { take } from '../util';

export type CheckoutArtist = {
  name?: string;
  links?: CheckoutArtistLink.CheckoutArtistLink[];
};

export const fromGql = (gqlItem: GQLItem): CheckoutArtist => ({
  ...take<CheckoutArtist>(gqlItem,
    'name',
  ),
  links: gqlItem.links ? CheckoutArtistLink.fromGqlCollection(gqlItem.links) : [],
});

export const fromGqlCollection = (gqlItems: GQLItem[]): CheckoutArtist[] => gqlItems.map(fromGql);
